import React from 'react'
import cx from 'classnames'

import s from './SingleOrderDetails.module.css'

const SingleOrderDetails = ({ orderDetails, className }) => {
  return (
    <div className={cx(s.modal, className)}>
      <div>
        {/* <div className={s.itemsWrapper}>
          {orderDetails.items.map((item) => {
            const options = item?.ItemNotes?.split(',')

            return (
              <div className={s.item}>
                <div className={s.itemRow}>
                  {item.Quantity}x{item.ItemName}
                </div>

                <div className={s.optionsTitle}>Options:</div>
                {options ? options?.map((item) => <div>{item}</div>) : null}
              </div>
            )
          })}
        </div> */}

        <div className={s.eventsWrapper}>
          <table className="space-y-4">
            {orderDetails.events.map((event, index) => (
              <tr key={index} className={s.eventRow}>
                <td>{`${index + 1}. ${event.status}`}</td>
                <td className="px-4">-</td>
                <td>
                  <span className={s.eventTime}>{event.datetime_local}</span>
                </td>
              </tr>
            ))}
          </table>
        </div>
      </div>
    </div>
  )
}

export default SingleOrderDetails
